import { LiveClassSurveyComponent } from './live-class-survey/live-class-survey.component';
import { NewLevelCongratulationNotificationComponent } from './new-level-congratulation-notification/new-level-congratulation-notification.component';
import { NotificationEventType } from './types/notification-event-type';
import { GenericNotificationComponent } from './generic-notification/generic-notification.component';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TeacherLiveClassFeedbackModalComponent } from '../teacher-feedback/teacher-liveclass-feedback-modal/teacher-liveclass-feedback-modal.component';
import { BaseNotificationModalDataOptions } from './base-notification-modal/base-notification-modal.component';

export const NOTIFICATION_COMPONENT_MAP = {
  [NotificationEventType.LIVE_CLASS_SURVEY]: LiveClassSurveyComponent,
  [NotificationEventType.NEW_LEVEL_CONGRATULATION]: NewLevelCongratulationNotificationComponent,
  [NotificationEventType.TEACHER_FEEDBACK]: TeacherLiveClassFeedbackModalComponent,
  [NotificationEventType.GENERIC_POPUP]: GenericNotificationComponent,
};

export const NOTIFICATION_MODAL_OPTIONS_MAP: { [key in NotificationEventType]?: NgbModalOptions } = {
  [NotificationEventType.NEW_LEVEL_CONGRATULATION]: { centered: true },
};

export const NOTIFICATION_MODAL_ADDITIONAL_DATA_MAP: { [key in NotificationEventType]?: BaseNotificationModalDataOptions } = {
  [NotificationEventType.LIVE_CLASS_SURVEY]: { showCloseButton: false },
}


// WEBPACK FOOTER //
// ./ts/app/shared/notification-components.map.ts